import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import $ from 'jquery';
import { Card, Col, Form, Row } from 'react-bootstrap';
import { CardHeader, CardTitle } from '../../styles/components/common/Table';
import { LinkButton } from '../../styles/components/common/Button';
import FormSeo from '../../components/commons/FormSeo';
import FormButton from '../../components/Form/Button';
import FormImage from '../../components/Form/image';
import Input from '../../components/Form/Input';
import FormSelect from '../../components/Form/FormSelect';
import Select from '../../components/Form/Select';

const options = [
      {
            id: 'PDF',
            title: 'PDF'
      }
];

const CatalogueCreate = () => {
      const [title, setTitle] = useState('');
      const [image, setImage] = useState('');
      const [imageUrl, setImageUrl] = useState('');

      const [file, setFile] = useState('');
      const [fileUrl, setFileUrl] = useState('');

      const [type, setType] = useState('');
      const [status, setStatus] = useState('');
      const [loading, setLoading] = useState(false);

      const [seoTitle, setSeoTitle] = useState(null);
      const [seoKeyword, setSeoKeyword] = useState(null);
      const [seoDescription, setSeoDescription] = useState(null);

      const handleFormSubmit = async (event) => {
            event.preventDefault();
            setLoading(true);
            const data = {
                  title: title,
                  type: type,
                  file: file,
                  image: image,
                  status: status,
                  seo_title: seoTitle,
                  seo_keyword: seoKeyword,
                  seo_description: seoDescription
            };

            await axios
                  .post(
                        `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/catalogues`,
                        data,
                        {
                              headers: {
                                    Authorization: `Bearer ${JSON.parse(
                                          localStorage.getItem('token')
                                    )}`,
                                    'Content-Type': 'multipart/form-data'
                              }
                        }
                  )
                  .then((response) => {
                        if (response.data.result === 'success') {
                              toast.success(response.data.message);
                              $('form').trigger('reset');
                              setFileUrl('');
                              setImageUrl('');
                        }
                        if (response.data.result === 'error') {
                              if (response.data.message.title) {
                                    toast.error(response.data.message.title);
                              }
                              if (response.data.message.type) {
                                    toast.error(response.data.message.type);
                              }
                              if (response.data.message.file) {
                                    toast.error(response.data.message.file);
                              }
                              if (response.data.message.image) {
                                    toast.error(response.data.message.image);
                              }
                              if (response.data.message.seo_title) {
                                    toast.error(
                                          response.data.message.seo_title
                                    );
                              }
                              if (response.data.message.seo_keyword) {
                                    toast.error(
                                          response.data.message.seo_keyword
                                    );
                              }
                              if (response.data.message.seo_description) {
                                    toast.error(
                                          response.data.message.seo_description
                                    );
                              }
                              if (response.data.message.status) {
                                    toast.error(response.data.message.status);
                              }
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoading(false);
      };

      return (
            <>
                  <Form onSubmit={handleFormSubmit}>
                        <div className="">
                              <Row>
                                    <Col lg={12}>
                                          <Card>
                                                <CardHeader>
                                                      <CardTitle>
                                                            Create Catalogue
                                                      </CardTitle>
                                                      <LinkButton
                                                            to="/dashboard/catalogues"
                                                            className="btn btn-secondary"
                                                      >
                                                            Back
                                                      </LinkButton>
                                                </CardHeader>
                                                <div className="card-body">
                                                      <div className="row g-3">
                                                            <Input
                                                                  title="Title"
                                                                  classes={8}
                                                                  required={
                                                                        true
                                                                  }
                                                                  handleChange={
                                                                        setTitle
                                                                  }
                                                            />
                                                            <FormSelect
                                                                  title="Type"
                                                                  classes={4}
                                                                  required={
                                                                        true
                                                                  }
                                                                  options={
                                                                        options
                                                                  }
                                                                  loading={
                                                                        loading
                                                                  }
                                                                  setData={
                                                                        setType
                                                                  }
                                                            />
                                                            <Select
                                                                  title="Status"
                                                                  classes={4}
                                                                  setStatus={
                                                                        setStatus
                                                                  }
                                                            />
                                                      </div>
                                                </div>
                                          </Card>

                                          <Card className="mt-4">
                                                <Card.Body>
                                                      <Row className="g-3">
                                                            <FormImage
                                                                  title="Feature Image"
                                                                  setImage={
                                                                        setImage
                                                                  }
                                                                  setImageUrl={
                                                                        setImageUrl
                                                                  }
                                                                  grid={2}
                                                                  required={
                                                                        true
                                                                  }
                                                                  imageUrl={
                                                                        imageUrl
                                                                  }
                                                            />
                                                            <FormImage
                                                                  title="PDF File"
                                                                  setImage={
                                                                        setFile
                                                                  }
                                                                  setImageUrl={
                                                                        setFileUrl
                                                                  }
                                                                  imageUrl={
                                                                        fileUrl
                                                                  }
                                                                  imageType="application/pdf"
                                                            />
                                                      </Row>
                                                </Card.Body>
                                          </Card>

                                          <FormSeo
                                                setSeoDescription={
                                                      setSeoDescription
                                                }
                                                setSeoTitle={setSeoTitle}
                                                setSeoKeyword={setSeoKeyword}
                                          />

                                          <Card className="mt-4 mb-5">
                                                <Card.Body>
                                                      <Row>
                                                            <Col lg={12}>
                                                                  <FormButton
                                                                        title="Submit"
                                                                        loading={
                                                                              loading
                                                                        }
                                                                  />
                                                            </Col>
                                                      </Row>
                                                </Card.Body>
                                          </Card>
                                    </Col>
                              </Row>
                        </div>
                  </Form>
            </>
      );
};

export default CatalogueCreate;
